module.exports = __webpack_public_path__ + "img/phone-neotag-banner.b43193d2.png";